module.exports = __webpack_public_path__ + "img/award-1.c14c1a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/awards/award-1.jpg
// module id = 1286
// module chunks = 1